import React from 'react';
export var IconPaymentMastercard = function IconPaymentMastercard(_ref) {
  var _ref$height = _ref.height,
    height = _ref$height === void 0 ? '32' : _ref$height,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? '50' : _ref$width;
  return /*#__PURE__*/React.createElement("svg", {
    "data-testid": "icon-payment-mastercard",
    height: height,
    viewBox: "0 0 50 32",
    width: width,
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "Mastercard logo"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    height: "32",
    rx: "6",
    width: "50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.713 24.236h9.423V7.303h-9.423z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.311 15.77a10.75 10.75 0 0 1 4.113-8.467c-4.676-3.676-11.446-2.864-15.121 1.812-3.676 4.675-2.864 11.446 1.812 15.121a10.769 10.769 0 0 0 13.31 0 10.75 10.75 0 0 1-4.114-8.467",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.848 15.77c0 5.947-4.821 10.768-10.768 10.768a10.77 10.77 0 0 1-6.656-2.302c4.676-3.677 5.486-10.448 1.81-15.124a10.768 10.768 0 0 0-1.81-1.81C30.1 3.629 36.87 4.439 40.545 9.115a10.77 10.77 0 0 1 2.303 6.655z",
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 23.051v-1h-.209l-.24.688-.24-.688h-.208v1h.147v-.754l.225.65h.153l.225-.652v.756H43zm-1.25 0v-.83h.353v-.17h-.898v.17h.353v.83h.192z",
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#AEBCC6"
  }, /*#__PURE__*/React.createElement("rect", {
    height: "31",
    rx: "6",
    width: "49",
    x: ".5",
    y: ".5"
  }))));
};